/**
 * Guía: Pagos Programados.
 *
 * Contenido derivado del capítulo **22** del manual: §0 (la configuración y
 * el historial de corridas, y que la perilla que importa es el modo) y del
 * flujo F4 §4, que describe los tres niveles.
 *
 * El paso del modo es el central: define cuánto dinero sale sin que un
 * humano lo mire.
 */

import type { TourFlow } from '../types';

const PROGRAMADOS_PATH = '/finance/scheduled-payouts';

export const c22PagosProgramados: TourFlow = {
  id: 'admin.scheduled-payouts',
  chapter: '22',
  title: 'Pagos programados',
  summary:
    'El pago solo: cuánto sale sin que nadie lo mire, y qué significa cada parada de una corrida.',
  href: PROGRAMADOS_PATH,
  requiresCountry: true,
  estimatedMin: 4,
  steps: [
    {
      id: 'intro',
      title: 'Aquí se configura el pago automático',
      body:
        'Liquidaciones es el pago a mano. Ésta es el pago solo: cada cuánto se generan, a ' +
        'qué hora, con qué mínimo y con cuánta autonomía. Y debajo, el historial de cada ' +
        'ejecución.',
      route: PROGRAMADOS_PATH,
    },
    {
      id: 'three-audiences',
      title: 'Tres destinatarios, tres configuraciones',
      body:
        'Comercios, creadores y asesores se programan por separado: cada uno con su ' +
        'frecuencia y su mínimo. Cambiar la de comercios no toca las otras dos.',
      target: 'admin.scheduledPayouts.kindTabs',
      placement: 'bottom',
      optionalTarget: true,
    },
    {
      id: 'mode',
      title: 'El modo decide cuánto sale sin que nadie mire',
      body:
        'Sólo generar deja todo esperando aprobación. Automático hasta un tope transfiere ' +
        'solo por debajo de ese límite. Totalmente automático no pregunta. Es la perilla con ' +
        'más consecuencia de la pantalla.',
    },
    {
      id: 'funds-guard',
      title: 'Sin fondos, la corrida se retiene entera',
      body:
        'Si el saldo de la pasarela no cubre el total, no se transfiere a medias: se para ' +
        'todo. Un lote a medias deja a unos comercios pagados y a otros no, sin registro de ' +
        'por qué.',
    },
    {
      id: 'three-stops',
      title: 'Tres paradas que desde fuera se ven igual',
      body:
        'Esperando aprobación, retenida por fondos, y dispersada con fallos parciales. Las ' +
        'tres llegan como «no me han pagado» y se resuelven distinto: mirar en cuál está la ' +
        'corrida es el primer paso.',
    },
    {
      id: 'snapshot',
      title: 'Cada corrida guarda las reglas con las que se ejecutó',
      body:
        'Cambiar la configuración después no reescribe lo que ya pasó. Por eso una corrida ' +
        'antigua puede haberse comportado distinto a lo que hoy dice la pantalla, y es ' +
        'correcto.',
    },
  ],
};
